export default __webpack_public_path__ + "static/media/mision.805fe33b.png";